import { BUNDLES_DELETE_BUNDLE } from 'apiRoutes';
import { ConfirmationModal } from 'components/common/ConfirmationModal/ConfirmationModal';
import useSubmit, { POST } from 'hooks/useSubmit';

export const DeleteBundleModal: React.FC<{
	setShowModal: (show: boolean) => void;
	showModal: boolean;
	bundleId: number;
	onBundleDeleted: () => void;
}> = ({ setShowModal, showModal, bundleId, onBundleDeleted }) => {
	const [deleteBundle, status] = useSubmit(BUNDLES_DELETE_BUNDLE, POST, {
		messageOnError: 'An error occurred, please try again!',
		messageOnSuccess: 'Bundle deleted successfully',
		showApiError: true,
	});

	const onDeleteBundle = async (comment?: string) => {
		const result = await deleteBundle({
			bundleId,
			comment: comment ?? null,
		});
		if (result.success) {
			onBundleDeleted();
			setShowModal(false);
		}
	};

	return (
		<ConfirmationModal
			showModal={showModal}
			setShowModal={setShowModal}
			onSubmit={onDeleteBundle}
			header="Delete Bundle"
			text="Are you sure you want to delete this bundle?"
			buttonText="Delete Bundle"
			loadingStatus={status}
		/>
	);
};
